import { ReactElement } from 'react';
import { getMarketContent } from 'utils/marketContent';
import FeatureBox from './feature-box';
import './index.scss';

export default function PromoBanner(): ReactElement {
  const market = getMarketContent();
  const data = market.homePage.featuredCards;
  return (
    <section id="promo-banner" className="container py-4 px-4 lg:px-2 xl:px-0">
      <div className="grid">
        {data.map(item => (
          <div
            key={item.backgroundImg}
            className="col-12 lg:col-4 pb-4 md:pb-0"
          >
            <FeatureBox {...item} />
          </div>
        ))}
      </div>
    </section>
  );
}
